export default "__VITE_ASSET__5147df08__"